<template>
  <div>
    <Pos_warehouse_product_list/>
  </div>
</template>

<script>
import Pos_warehouse_product_list
  from "@/components/adminArin/pos_system/warehouse/manage_product/Pos_warehouse_product_list";
export default {
  name: "PosWarehouseProductList",
  components: {
    Pos_warehouse_product_list
  }
}
</script>

<style scoped>

</style>
